import React from "react";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import AboutBg from "../../../../Assets/Images/About/AboutBg.png";
import { aboutusContent, brandName } from "../../../../Constants/content";
import { FaCheckCircle } from "react-icons/fa";
import { primaryColor } from "../../../../Constants/Colors";

const AboutSection = () => {
  return (
    <section className="py-5 border-top">
      <Container>
        <Row className="align-items-center">
          <Col md={12}>
            <div>
              <div className="d-flex align-items-center mb-2">
                <small className="text-muted text-uppercase me-3">
                  About us
                </small>
                <div
                  style={{ flex: 1, height: "2px", backgroundColor: "#ccc" }}
                ></div>
              </div>

              <h1 className="mt-2 mb-4 fw-bold text-primary col-12 col-lg-8">
                {aboutusContent[0]}
              </h1>
            </div>
          </Col>
          <Col md={6} className="mb-4 mb-md-0">
            <div className="position-relative">
              <div
                className="bg-gradient border-0 rounded-4 p-2"
                style={{ display: "inline-block" }}
              >
                <Image
                  src={AboutBg} // Replace with your actual image path
                  alt="Team at work"
                  fluid
                  rounded
                  className="img-fluid"
                />
              </div>
            </div>
          </Col>
          <Col md={6}>
            <p className="text-muted">{aboutusContent[1]}</p>
            <p className="text-muted">{aboutusContent[2]}</p>
            <ul className="list-unstyled">
              {aboutusContent.slice(3, 6).map((item, index) => (
                <li className="mb-2" key={index}>
                  <FaCheckCircle color={primaryColor} className="me-2" />
                  <span className="fw-bold">{item}</span>
                </li>
              ))}

            </ul>
            <h5 className="text-primary fw-bold mt-4">
              Your Success. Our Mission.
            </h5>
            <p className="fw-semibold">{brandName}.</p>
            <Button variant="success" className="rounded-pill px-4 py-2">
              KNOW MORE ABOUT US <i className="fa fa-arrow-right ms-2"></i>
            </Button>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutSection;
